import { ImportExportHistoryTableView } from '@/components/ImportExportHistory/Table';
import { memo } from 'react';
import { useImportExportHistoryTable } from './hooks/useImportExportHistoryTable';

const InnerTable = memo(() => {
  const { table, actionHandlers } = useImportExportHistoryTable();
  return (
    <ImportExportHistoryTableView
      table={table}
      actionHandlers={actionHandlers}
    />
  );
});
InnerTable.displayName = 'InnerTable';

export const ImportExportHistoryTableViewWrapper = memo(() => {
  return <InnerTable />;
});
ImportExportHistoryTableViewWrapper.displayName =
  'ImportExportHistoryTableViewWrapper';
